import moment from "moment-timezone"

export const getDateRange = value => {
  let startDate = null
  let endDate = null

  if (value === "this") {
    startDate = getThisMonth({ useStart: true, value })
    endDate = getThisMonth({ useStart: false, value })
  } else if (value === "last") {
    startDate = getLastMonth({ useStart: true, value })
    endDate = getLastMonth({ useStart: false, value })
  } else if (value === "7days") {
    startDate = get7Days({ useStart: true, value })
    endDate = get7Days({ useStart: false, value })
  } else if (value === "30days") {
    startDate = get30Days({ useStart: true, value })
    endDate = get30Days({ useStart: false, value })
  } else {
    startDate = getByYear({ useStart: true, value })
    endDate = getByYear({ useStart: false, value })
  }

  return {
    startDate: startDate.format(),
    endDate: endDate.format()
  }
}

const getThisMonth = ({ useStart }) =>
  useStart ? moment().startOf("month") : moment().endOf("month")

const getLastMonth = ({ useStart }) =>
  useStart
    ? moment()
        .subtract(1, "months")
        .startOf("month")
    : moment()
        .subtract(1, "months")
        .endOf("month")

const get7Days = ({ useStart }) =>
  useStart
    ? moment()
        .subtract(7, "days")
        .startOf("day")
    : moment().endOf("day")

const get30Days = ({ useStart }) =>
  useStart
    ? moment()
        .subtract(30, "days")
        .startOf("day")
    : moment().endOf("day")

const getByYear = ({ useStart, value }) =>
  useStart
    ? moment()
        .year(parseInt(value))
        .month(0)
        .date(1)
        .startOf("day")
    : moment()
        .year(parseInt(value))
        .month(11)
        .date(31)
        .endOf("day")
